import React, {useState, useEffect} from 'react';
import LivenessV7 from './LivenessV7';
import './index.css'
import {useLocation} from "react-router-dom";
import {isMovil} from "../../cardCapture/utils";
import {LivenessV5} from "../v5";

export default function LivenessV7Wrapper() {
    const location = useLocation();
    const [config, setConfig] = useState({});
    const [configLoading, setLoading] = useState(true);

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    const projectName = params.projectName || 'Default'

    function setStyles(stylesObject) {
        const root = document.documentElement;
        root.style.setProperty('--background-color', stylesObject.backgroundColor);
        root.style.setProperty('--message-color', stylesObject.messageColor);
        root.style.setProperty('--message-back-color', stylesObject.messageBackgroundColor);
        root.style.setProperty('--guide-color', stylesObject.guideColor);
        root.style.setProperty('--success-color', stylesObject.successColor);
        root.style.setProperty('--error-color', stylesObject.errorColor);
        root.style.setProperty('--message-error-color', stylesObject.messageErrorColor);
        root.style.setProperty('--font-size', stylesObject.fontSize);
    }

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const url = `https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`;
                const response = await fetch(url, { method: 'GET' });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setConfig(data);
                setStyles(data.styles)
            } catch (error) {
                const defaultUrl = `https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`;
                const response = await fetch(defaultUrl, { method: 'GET' });
                const data = await response.json();
                setConfig(data);
                setStyles(data.styles)
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, [projectName]);

    if (configLoading) {
        return null
    }

    return <LivenessV7 key={location.key} configLoading={configLoading} configValue={config} />
}
